import { memo, useCallback } from "react";

import {
  Box,
  Button,
  Flex,
  Heading,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import { showToast } from "components/toast/Toast";
import useApi from "hooks/useApi";
import { CREATE_USER } from "constants/endpoints";

const VisibilityModal = ({ userData, refetchData, isOpen, onClose, modalType }) => {
  const { apiCall } = useApi();
  const { first_name, last_name, _id, number_private , enable_lead_automation} = userData || {};

  const isLeadModal= modalType === 'Change Lead Automation'

  const updateUserPrivacy = useCallback(async () => {
    try {
      const data = await apiCall.patch(`${CREATE_USER}`, {
        _id,
        ...(isLeadModal
          ? { enable_lead_automation: !enable_lead_automation }
          : { number_private: !number_private }),
      });
      if (data) {
        onClose();
        refetchData();
        showToast({
          message: `User Updated`,
          success: true,
          customStyle: {
            background: "#52c41a",
            color: "#fff",
            padding: "10px",
          },
        });
      }
    } catch (error) {
      console.log(error);
      showToast({
        message: error?.message || `Error Updating user`,
        success: false,
        customStyle: {
          background: "#F24052",
          color: "#fff",
          padding: "10px",
        },
      });
    }
  }, [isLeadModal, enable_lead_automation, number_private ]);

  return (
    <Modal size="xl" isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <Heading size="md" color="gray.800">
            {!isLeadModal ? 'Change Number Visibility' : 'Change Number Visibility' }
          </Heading>
          <Button
            variant="outline"
            borderRadius="full"
            position="absolute"
            top={2}
            right={4}
            zIndex={1}
            size="sm"
            onClick={onClose}
          >
            x
          </Button>
        </ModalHeader>
        <ModalBody>
          <Flex flexDirection={"column"}>
            {isLeadModal ? (<Text>
              <span style={{ fontWeight: 600 }}>
                {first_name} {last_name} is 
              </span>{" "}
              currently{" "}
              <span
                style={{
                  fontWeight: 600,
                  color: enable_lead_automation ? "#0f0" : "#f00",
                }}
              >
                {enable_lead_automation ? "Included" : "Not Included"} in Lead Automation
              </span>
            </Text>) : (
              <Text>
              <span style={{ fontWeight: 600 }}>
                {first_name} {last_name}'s
              </span>{" "}
              number is currently{" "}
              <span
                style={{
                  fontWeight: 600,
                  color: number_private ? "#0f0" : "#f00",
                }}
              >
                {number_private ? "Not Visible" : "Visible"}
              </span>
            </Text>
            )}
            
            <Text>Are you sure you want to change the status?</Text>
          </Flex>
        </ModalBody>
        <ModalFooter>
          <Flex gap={1}>
            <Button variant="outline" onClick={onClose}>
              Cancel
            </Button>
            <Button
              background={"linear-gradient(180deg, #22ACEE 0%, #0177B4 100%)"}
              color="#ffffff"
              mr={3}
              onClick={updateUserPrivacy}
            >
              Confirm
            </Button>
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default memo(VisibilityModal);
